<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住培生月度绩效考评' label2="评分详细" url="/achievement/stu/scorerecordlist"></PageHead>
      <div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div style="width: 100%;overflow: auto;">
            <div v-html="tabScore">
            </div>
          </div>
          <div style="margin: 15px;">
            <div style="font-size: 18px;">优秀评分理由</div>
            <el-table :data="remarkTable">
              <el-table-column prop="StuName" label="学员" width="150">
              </el-table-column>
              <el-table-column prop="StuNo" label="工号" width="150">
              </el-table-column>
              <el-table-column prop="ETDContent" label="评分项" width="200">
              </el-table-column>
              <el-table-column prop="ContentRemark" label="理由">
              </el-table-column>
            </el-table>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">修改意见：</label>
            <div class="col-xl-10" style="padding-top: 7px;">
              {{editinfo}}
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">签字凭证：</label>
            <div class="col-xl-10">
              <el-table v-loading="loading" :data="tableFileData" stripe style="width: 100%" size="medium" v-if="tableFileData.length != 0">
                <el-table-column label="附件名">
                  <template slot-scope="scope">
                    {{scope.row.FileName}}<span style="color: #409EFF;cursor: pointer;padding-left: 10px;" @click="See(scope.row)">[查看]</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">附件描述：</label>
            <div class="col-xl-10" style="padding-top: 7px;">
              {{cpifiledesc}}
            </div>
          </div> -->
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">审核意见：</label>
            <div class="col-xl-10" style="padding-top: 7px;">
              {{cpistatusname}}。{{cpicinfo}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="凭证查看" :visible.sync="dialogImgVisible">
      <el-image style="width: 100%;" :src="imgurl"></el-image>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'StuScorerecord',
    data() {
      return {
        condition: {
          token: '',
          id: ''
        },
        tabScore: '',
        cpifiledesc: '',
        cpistatusname: '',
        cpicinfo: '',
        editinfo: '',
        tableFileData: [],
        FileGuid: '',
        dialogImgVisible: false,
        imgurl: '',
        remarkTable:[]
      }
    },
    methods: {
      See: function(row) {
        this.imgurl = this.$utils.Url.zpgl + '/file/' + row.FileName
        this.dialogImgVisible = true
      },
      LoadCPIDetail: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/CPIDetail', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tabScore = res.data.Data
              that.LoadCPIRemark()
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.tabScore = ''
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadCPIRemark: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetCPIRemark', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.remarkTable = res.data.Data
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.remarkTable = []
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadCPIInfo: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ViewInfo', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.cpifile = res.data.Data.CPIFile
              this.cpifiledesc = res.data.Data.CPIFileDesc
              this.cpistatusname = res.data.Data.CPIStatusName
              this.cpicinfo = res.data.Data.CPICInfo
              this.editinfo = res.data.Data.CPICRemark
              this.FileGuid = res.data.Data.CPIRemark4
              this.LoadFileList()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadFileList: function() {
        this.loading = true
        var args = {
          token: this.condition.token,
          guid: this.FileGuid
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/FileListByGuid', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableFileData = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.id = this.$route.params.id
      this.LoadCPIDetail()
      this.LoadCPIInfo()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/stuscore.css'
</style>
